import { render, staticRenderFns } from "./teachers-main.vue?vue&type=template&id=f0ddbb16&lang=pug&"
import script from "./teachers-main.vue?vue&type=script&lang=js&"
export * from "./teachers-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports